import Circos from '../circos';
import ReportHeader from './report_header';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var GraphicalOverview = function GraphicalOverview(_ref) {
  var queries = _ref.queries,
    program = _ref.program,
    plugins = _ref.plugins;
  /**
  * Does the report have at least two hits? This is used to determine
  * whether Circos should be enabled or not.
  */
  var atLeastTwoHits = function atLeastTwoHits() {
    var hitNum = 0;
    return queries.some(function (query) {
      hitNum += query.hits.length;
      return hitNum > 1;
    });
  };
  var renderContent = function renderContent() {
    if (!atLeastTwoHits()) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Circos, {
        queries: queries,
        program: program
      }), plugins.generateStats(queries)]
    });
  };
  return /*#__PURE__*/_jsx(ReportHeader, {
    name: "Graphical Overview",
    renderContent: renderContent,
    renderable: atLeastTwoHits()
  });
};
export default GraphicalOverview;